import ToolCardSkeleton from "./ToolCardSkeleton";

interface ToolsGridSkeletonProps {
  count?: number;
}

export default function ToolsGridSkeleton({
  count = 3,
}: ToolsGridSkeletonProps) {
  return (
    <div
      className="grid gap-6"
      style={{
        gridTemplateColumns: "repeat(auto-fill, minmax(auto, 350px))",
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <ToolCardSkeleton key={index} />
      ))}
    </div>
  );
}
